import {useLayoutEffect, useState} from 'react';

/**
 * Returns the current window dimensions, updating on resize.
 *
 * @returns A tuple `[width, height]` in pixels.
 *
 * @example
 * const [width, height] = useWindowResize();
 */
export const useWindowResize = (): [number, number] => {
    const [size, setSize] = useState<[number, number]>([0, 0]);
    useLayoutEffect(() => {
        function onSizeUpdate() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', onSizeUpdate);
        onSizeUpdate();
        return () => window.removeEventListener('resize', onSizeUpdate);
    }, []);
    return size;
};
